import Portal from "components/layout/Portal";
import usePresence, { type PresenceState, type UsePresenceOptions } from "hooks/usePresence";

export type AnimatedPortalProps = {
    visible?: boolean;
    target?: HTMLElement | null;
    children: React.ReactNode | ((state: PresenceState) => React.ReactNode);
    presenceOptions?: UsePresenceOptions;
};

/**
 * Portal that stays mounted through exit so children can animate out.
 * Children may be a render prop receiving the presence state.
 */
const AnimatedPortal: React.FC<AnimatedPortalProps> = ({
    visible = false,
    target = null,
    children,
    presenceOptions,
}) => {
    const { mounted, state } = usePresence(visible, presenceOptions);

    if (!mounted) return null;

    const content = typeof children === "function" ? children(state) : children;

    return (
        <Portal visible={true} target={target}>
            {content}
        </Portal>
    );
};

export default AnimatedPortal;
